// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Y05DC","col":"CardReaderDesc_col__1kXst","label":"CardReaderDesc_label__2Vvzk"};